import React, {useContext, useEffect} from 'react';

import {ContextPlayer} from '../player/PlayerProvider';
import {ContextGlobal} from '../../globalProvider';

const Timer = () => {
	const {state, dispatch} = useContext(ContextPlayer);
	const global = useContext(ContextGlobal);

	

	useEffect(() => {
		let interval = null;
		let stop = new Date();
		
		if(state.playing && !global.state.config){
			
			interval= setInterval(() => {
				const now = new Date()
				dispatch({type:"UpdateTimeout",timeout:now - stop});
				stop = now;
			}, 1000);
		}

		return () => clearInterval(interval);
	}, [state.playing,global.state.config, dispatch]);

	return(<div></div>);
};

export default Timer;